import {getInitialMeta} from "@helpers/HelperInitialPageState";
// Data file for component
///////////////////////////////////////////////////////////////////////////////////////////
import flag from '@baseImg/icons/voltage-icon.webp';

const BG = {
	page: 'Home',
	brandColor: 'color-brand-orange-400',
	title: '<span class="nowrap">Сигурен</span> <span class="nowrap">хостинг за</span> <span class="nowrap">всеки сайт</span>',
	rightTitle: '<span class="nowrap">Запази</span> <span class="nowrap">своя домейн</span>',
	list:
	  [],
	additionalText: 'Стартирай личен проект с новия хостинг план СуперЛайт на супер цена. Гарантирана сигурност и поддръжка.',
	priceServiceId: 'plan_00',
	// priceServiceId: 'plan_wpai_01',
	priceTerm: 12,
	showMonthly: true,
	textColor: 'white',
	buttonText: 'Виж хостинг планове',
	buttonAction: 'RedirectToHostingFromHomePageBanner',
	buttonParams: [],
	ButtonModal: '',
	domainForm: {
		placeHolder: 'www.mysupersite.com',
		buttonText: 'Търсене на домейн',
		animationTexts: [
			"www.mysupersite.com",
			"www.mysupersite.bg",
			"www.mysupersite.eu",
			"www.mysupersite.net"
		]
	},
	domainPriceServiceIds: [
		'bg',
		'com',
		'eu'
	],
	domainPriceServiceIdsTerm: 12,
	infoBar: {
		text: '<img src="' + flag + '" alt="Flash sale" title="Flash sale - SuperHosting.BG" width="22" height="22"/> Flash Sale! Запази .BG и .EU заедно и вземи над 50% отстъпка до 11 ноември!',
		buttonText: 'Поръчай',
		buttonUrl: getInitialMeta('siteURL') + 'web-hosting-register-domains.php',
		layout: 'default'
	}
}

///////////////////////////////////////////////////////////////////////////////////////////

const EN = {
	page: 'Home',
	brandColor: 'color-brand-orange-400',
	title: '<span class="nowrap">Secure</span> <span class="nowrap">hosting for</span> <span class="nowrap">your website</span>',
	rightTitle: '<span class="nowrap">Get</span> <span class="nowrap">your domain</span>',
	list:
	  [],
	additionalText: `
		<span class="nowrap">Launch your personal project with the</span>
		new SuperLite hosting plan at a super price.
		Guaranteed security and support.
	`,
	priceServiceId: 'plan_00',
	// priceServiceId: 'plan_wpai_01',
	priceTerm: 12,
	showMonthly: true,
	textColor: 'white',
	buttonText: 'View hosting plans',
	buttonAction: 'RedirectToHostingFromHomePageBanner',
	buttonParams: [],
	ButtonModal: '',
	domainForm: {
		placeHolder: 'www.mysupersite.com',
		buttonText: 'Domain Search',
		animationTexts: [
			"www.mysupersite.com",
			"www.mysupersite.bg",
			"www.mysupersite.eu",
			"www.mysupersite.net"
		]
	},
	domainPriceServiceIds: [
		'bg',
		'com',
		'eu'
	],
	domainPriceServiceIdsTerm: 12,
	infoBar: {
		text: '<img src="' + flag + '" alt="Flash sale" title="Flash sale - SuperHosting.BG" width="22" height="22"/> Flash Sale! Get .BG & .EU together and save over 50% until November 11!',
		buttonText: 'Order',
		buttonUrl: getInitialMeta('siteURL') + 'web-hosting-register-domains.php',
		layout: 'default'
	}
}

///////////////////////////////////////////////////////////////////////////////////////////

const dataMap = {
	bg: BG,
	en: EN
};
const lang = getInitialMeta('pageLang') ?? 'bg';

///////////////////////////////////////////////////////////////////////////////////////////

export default dataMap[lang];